import { Box, Paper, Tab, Tabs } from '@mui/material'
import { Page } from 'Common/Page/Page'
import { PageHeader, TabPanel } from 'Common/Supplyvue-ui'
import { useBreadcrumbsData } from 'Common/Breadcrumbs/Breadcrumbs.data'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { usePlanStatus } from './EditSettings.data'
import { PLAN_STATUS } from 'Common/Constants/Constants'
import { PlanDataIsLoading } from './EditSettingsPlanIsBeingLoaded.view'
import { Loader } from 'Common/Loader/Loader'
import { FrozenMovementTab } from './FrozenMovementTab.view'
import { FrozenProductionTab } from './FrozenProductionTab.view'
import { BatchParametersTab } from 'Features/SystemOfRecords/Tabs/BatchParametersTab.view'
import { WorkCentreParametersTab } from 'Features/SystemOfRecords/Tabs/WorkCentreParametersTab.view'
import { CapacityParametersTab } from 'Features/SystemOfRecords/Tabs/CapacityParametersTab.view'
import { ConstrainingParametersTab } from 'Features/SystemOfRecords/Tabs/ConstrainingParametersTab.view'
import { InventoryParametersTab } from 'Features/SystemOfRecords/Tabs/InventoryParametersTab.view'
import { TemplateParametersTab } from 'Features/SystemOfRecords/Tabs/TemplateParametersTab.view'
import { WorkcentreConstrainingHorizonsTab } from './WorkcentreConstrainingHorizonsTab.view'

const TABS = {
  FROZEN_PRODUCTION_TAB: 'tab-1',
  FROZEN_MOVEMENT_TAB: 'tab-2',
  BATCH_PARAMETERS_TAB: 'tab-3',
  CAPACITY_PARAMETERS_TAB: 'tab-4',
  CONSTRAINING_PARAMETERS_TAB: 'tab-5',
  INVENTORY_PARAMETERS_TAB: 'tab-6',
  TEMPLATE_PARAMETERS_TAB: 'tab-7',
  WORKCENTRE_PARAMETERS_TAB: 'tab-8',
  WORKCENTRE_CONSTRAINING_HORIZONS_TAB: 'tab-9',
}

export const EditSettingsPage = () => {
  const { planId } = useParams<{ planId: string }>()
  useBreadcrumbsData({
    plan_id: planId,
  })

  const [selectedTab, setSelectedTab] = useState(TABS.FROZEN_PRODUCTION_TAB)

  const { data: planStatusData, isLoading: isPlanDataLoading } = usePlanStatus(
    planId as string
  )

  const enabled =
    planStatusData &&
    planStatusData.status !== PLAN_STATUS.INITIATED &&
    planStatusData.status !== PLAN_STATUS.RUNNING

  if (isPlanDataLoading) {
    return <Loader />
  }
  return (
    <Page>
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
        sx={{ minWidth: 0, width: '100%' }}
      >
        <PageHeader title="Edit settings" />
        <Box
          display="flex"
          flexDirection="column"
          flex={1}
          alignItems="left"
          sx={{ minWidth: 0, overflow: 'hidden' }}
        >
          {planStatusData && planStatusData.status === PLAN_STATUS.INITIATED ? (
            <PlanDataIsLoading />
          ) : (
            <>
              {enabled && (
                <>
                  <Box>
                    <Paper>
                      <Tabs
                        value={selectedTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(_event, newValue) =>
                          setSelectedTab(newValue)
                        }
                      >
                        {/* <Tab
                          label="SKU - workcentre settings"
                          value={TABS.SKU_WC_SETTINGS_TAB}
                        /> */}
                        <Tab
                          label="Frozen production"
                          value={TABS.FROZEN_PRODUCTION_TAB}
                        />
                        <Tab
                          label="Frozen movements"
                          value={TABS.FROZEN_MOVEMENT_TAB}
                        />
                        <Tab
                          label="Batch parameters"
                          value={TABS.BATCH_PARAMETERS_TAB}
                        />
                        <Tab
                          label="Capacity parameters"
                          value={TABS.CAPACITY_PARAMETERS_TAB}
                        />
                        <Tab
                          label="Constraining parameters"
                          value={TABS.CONSTRAINING_PARAMETERS_TAB}
                        />
                        <Tab
                          label="Inventory parameters"
                          value={TABS.INVENTORY_PARAMETERS_TAB}
                        />
                        <Tab
                          label="Template parameters"
                          value={TABS.TEMPLATE_PARAMETERS_TAB}
                        />
                        <Tab
                          label="Workcentre parameters"
                          value={TABS.WORKCENTRE_PARAMETERS_TAB}
                        />
                        {/* <Tab
                          label="Workcentre"
                          value={TABS.WORKCENTRE_CONSTRAINING_HORIZONS_TAB}
                        /> */}
                      </Tabs>
                    </Paper>
                  </Box>
                  {/* <TabPanel
                    value={selectedTab}
                    index={TABS.SKU_WC_SETTINGS_TAB}
                  >
                    <EditSettingsTabView enabled={enabled} planId={planId} />
                  </TabPanel> */}
                  <TabPanel
                    value={selectedTab}
                    index={TABS.FROZEN_PRODUCTION_TAB}
                  >
                    <FrozenProductionTab
                      enabled={enabled}
                      planId={planId as string}
                    />
                  </TabPanel>
                  <TabPanel
                    value={selectedTab}
                    index={TABS.FROZEN_MOVEMENT_TAB}
                  >
                    <FrozenMovementTab
                      enabled={enabled}
                      planId={planId as string}
                    />
                  </TabPanel>
                  <TabPanel
                    value={selectedTab}
                    index={TABS.BATCH_PARAMETERS_TAB}
                  >
                    <BatchParametersTab planId={planId as string} />
                  </TabPanel>
                  <TabPanel
                    value={selectedTab}
                    index={TABS.CAPACITY_PARAMETERS_TAB}
                  >
                    <CapacityParametersTab planId={planId as string} />
                  </TabPanel>
                  <TabPanel
                    value={selectedTab}
                    index={TABS.CONSTRAINING_PARAMETERS_TAB}
                  >
                    <ConstrainingParametersTab planId={planId as string} />
                  </TabPanel>
                  <TabPanel
                    value={selectedTab}
                    index={TABS.INVENTORY_PARAMETERS_TAB}
                  >
                    <InventoryParametersTab planId={planId as string} />
                  </TabPanel>
                  <TabPanel
                    value={selectedTab}
                    index={TABS.TEMPLATE_PARAMETERS_TAB}
                  >
                    <TemplateParametersTab planId={planId as string} />
                  </TabPanel>
                  <TabPanel
                    value={selectedTab}
                    index={TABS.WORKCENTRE_PARAMETERS_TAB}
                  >
                    <WorkCentreParametersTab planId={planId as string} />
                  </TabPanel>
                  {/* <Box sx={{ width: '100%', overflow: 'hidden' }}>
                    <TabPanel
                      value={selectedTab}
                      index={TABS.WORKCENTRE_CONSTRAINING_HORIZONS_TAB}
                    >
                      <WorkcentreConstrainingHorizonsTab
                        planId={planId as string}
                      />
                    </TabPanel>
                  </Box> */}
                </>
              )}
            </>
          )}
        </Box>
      </Box>
    </Page>
  )
}
